module.exports = "/assets/js/a88e5d510e936df3a79bde8a7d85e388.svg";